module.exports = __webpack_public_path__ + "media/bootstrap-icons/door-closed-10259e6b.svg";